import { Attendee } from '../../../../components/AttendeesDialog';
import { StudentAttendee } from '../../../../services/tutorials/types';

export const studentToAttendee = (student: StudentAttendee): Attendee => ({
  id: student.studentId,
  firstName: student.firstName,
  lastName: student.lastName,
  note: student.note,
});
